import { render } from "./Consortium.vue?vue&type=template&id=4c03930e"
import script from "./Consortium.vue?vue&type=script&lang=js"
export * from "./Consortium.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__